import { mediums } from '../constants/acquisitionConstants';

import { usuariosListId } from '@rockalingua/shared/mailchimp/constants';

export default function comesFromMailchimp(
  utmMedium: string | null,
  utmTerm: string | null
): boolean {
  return (
    utmMedium?.toLowerCase() == mediums.email &&
    !!utmTerm?.includes(usuariosListId)
  );
}
